<template>
  <div
    :class="[
      isCollapse === '' ? 'footer': isCollapse === 't'? 'footer isCollapse': 'footer noCollapse',
      {'footer-drawer': getIfClientDrawerTag}
    ]">
    <p class="footer-info " v-html="`© ${getYear()}${$t('FOOTER_DES')}`">
      
    </p>
    <div class="footer-version">v2.2.3</div>
    <ul class="footer-bar">
      <li v-html="$t('FOOTER_LEGAL')"></li>
      <!--<li v-html="$t('FOOTER_PRIVACY')"></li>-->
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isCollapse: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('common', {
      getIfClientDrawerTag: 'getIfClientDrawerTag',
    }),
  },
  methods: {
    getYear(){
      return new Date().getFullYear()
    }
  }
};
</script>

<style>
  .footer {
    position: fixed;
    bottom: 0;
    height: 46PX;
    width: 100%;
    z-index: 99;
    padding: 5PX 12PX;
    border-top: 1PX solid #b2c1dc;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: width 0.3s;
  }
  .isCollapse{
    width: calc(100% - 84px);
  }
  .noCollapse{
    width: calc(100% - 255px);
  }
.footer-info {
  color: #81848a;
  font-size: 12PX;
  line-height: 16PX;
  flex: 1;
}
.en-lang .footer-info {
  font-size: 10PX;
}
.footer-version {
  font-size: 12px;
  text-align: end;
  margin: 0 30px 0 15px;
}
.footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  list-style: none;
  /* width: 100px; */
  text-decoration: underline;
}
.footer-bar li {
    cursor: pointer;
}
.footer-bar li:nth-child(1) {
  margin-right: 15px;
}
.footer-bar li a {
  color: #00338d;
  font-size: 14PX;
}
.footer-drawer {
    display: none;
  }
</style>
